import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Span, PATH, PWA_SESSION_KEY } from 'shared';
import alphaeonLogoWithText from 'images/utility-icons/alphaeon-logo-with-text.svg';
import alphaeonSupport from 'images/utility-icons/alphaeon-support.svg';
import closeIcon from 'images/utility-icons/close.svg';
import logoutIcon from 'images/utility-icons/logout.svg';
import { clearAccountLookupData } from '../slice';
import { clearFmaSession } from '../utils';
function Sidebar({ isOpen, onClose }) {
    const dispatch = useDispatch();
    const history = useHistory();
    const menuRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current &&
                !menuRef.current.contains(event.target) &&
                isOpen) {
                onClose();
            }
        };
        if (isOpen) {
            document.addEventListener('pointerdown', handleClickOutside);
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.removeEventListener('pointerdown', handleClickOutside);
            document.body.style.overflow = 'unset';
        };
    }, [isOpen, onClose]);
    const handleSignOut = () => {
        dispatch(clearAccountLookupData());
        clearFmaSession();
        sessionStorage.removeItem(PWA_SESSION_KEY);
        history.push(PATH.CREDIT_PORTAL + PATH.FIND_MY_ACCOUNT);
        onClose();
    };
    const handleSupportCenter = () => {
        window.open('https://www.myalphaeoncredit.com/patient-support', '_blank');
        onClose();
    };
    return (_jsxs(_Fragment, { children: [isOpen && (_jsx("div", { className: "sidebar__overlay", onClick: onClose, role: "button", tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === 'Escape') {
                        onClose();
                    }
                }, "aria-label": "Close sidebar" })), _jsx("div", { ref: menuRef, className: `sidebar__menu ${isOpen ? 'sidebar__menu--open' : 'sidebar__menu--closed'}`, children: _jsxs("div", { className: "sidebar__container", children: [_jsxs("div", { className: "sidebar__header", children: [_jsxs("div", { className: "sidebar__header-content", children: [_jsx("button", { onClick: onClose, className: "sidebar__close-button", "aria-label": "Close menu", children: _jsx("img", { src: closeIcon, alt: "Close" }) }), _jsx("img", { src: alphaeonLogoWithText, alt: "Alphaeon", className: "sidebar__logo" })] }), _jsx("div", { className: "sidebar__divider" })] }), _jsx("div", { className: "sidebar__nav", children: _jsxs("nav", { children: [_jsxs("div", { children: [_jsxs("button", { onClick: handleSupportCenter, className: "sidebar__nav-item", children: [_jsx("img", { src: alphaeonSupport, alt: "Support" }), _jsx(Span, { variant: "body-large", bold: true, children: "Support Center" })] }), _jsx("div", { className: "sidebar__nav-divider" })] }), _jsxs("button", { onClick: handleSignOut, className: "sidebar__nav-item", children: [_jsx("img", { src: logoutIcon, alt: "Sign out" }), _jsx(Span, { variant: "body-large", bold: true, children: "Sign Out" })] })] }) })] }) })] }));
}
export default Sidebar;
